/* eslint-disable react-hooks/exhaustive-deps */
import React, {useState, useEffect} from 'react'
import ContentLoader from './utilities/ContentLoader.js'
import ImagePreloader from './utilities/ImagePreloader.js'
import Tracking from './utilities/Tracking/Tracking.js'
import ReviewMenu from './utilities/ReviewMenu/ReviewMenu.js'
import Editor from './utilities/Editor/Editor.js'
import Module from './Module.js'
import config from './config.js'
import _ from 'lodash'

//global styles here - NOT mixins
import '../global-sass/reset.scss'
import '../global-sass/course-layout.scss'
import '../global-sass/global-styles.scss'
import '../global-sass/fonts.scss'
import {LocationProvider} from "./LocationContext/LocationContext";

// Course.js represents the whole course. Capable of loading different SCOs into Module.js
// This can be thought of as the 'review' view and data loading handler.

// 1) COURSE - Term to capture all material for a project. Could contain multiple SCOs(modules).
// 2) MODULE - Term to identify everything in a single SCO. Could contain multiple Lessons. If there is only one module in a Course, they might feel synonymous, but the module is the SCO structural component.
// 3) LESSON - Individual topic flow within a SCO. Contains a chain of Chapters.
// 4) CHAPTER - Chain of related interaction segments.
// 5) SEGMENT - The individual page/interaction/model unit to be strung together to form a Chapter/Lesson sequence.


const Course = props => {


    const query = window.location.search.substring(1);

    const isQA  = query.length && query.split("&").includes('qa=true');
    //integer indexes in an object for module/lesson/chapter/segment location
    const [currentLocation, setCurrentLocation] = useState(config.initialLocation);

    //ContentLoader will construct a big JSON object based on the various datasheets in /public/content
    const [contentData, setContentData] = useState(undefined);

    //progress will be a structural clone of contentData, with scoring/completion status
    const [progress, setProgress] = useState(undefined);

    //reset index fed to key value of each segment component - lives hear so it can be passed to ReviewMenu
    const [resetIndex, setResetIndex] = useState(0);

    //array of keys for editor pencils
    const [editorShortcut, setEditorShortcut] = useState([]);
    const [quit, setQuit]=useState(false)

    // set to "true" if we want to load data from google sheets
    const CONTENT_EDITOR = true;

    // ID of sheet to load data from if content editor
    const SHEET_ID = '';
    

    const setLocationValue = (key, val) => {
        //safe write for a specific key/val pair of currentLocation object
        let temp = _.cloneDeep(currentLocation);
        temp[key] = val;
        setCurrentLocation(temp);
    }

    const setLocationValues = locationObject => {
        let areKeysValid = Object.keys(locationObject).every((key,i) => {
            // check if all keys are valid
            return(['lesson', 'chapter', 'segment', 'module'].includes(key))
        })

        if (areKeysValid) {
            let temp = _.cloneDeep(currentLocation);
            Object.assign(temp, locationObject);
            setCurrentLocation(temp);
        }
    }

    const resetSco = () => {
        //sets currentLocation to initialLocation from config.js
        let temp = _.clone(config.initialLocation);
        temp.module = currentLocation.module
        setCurrentLocation(temp)
    }

    const resetSegment = () => {
        //increment resetIndex - will render a 'fresh' version of current segment
        setResetIndex(resetIndex+1)
    }

    // TODO: Implement an 'in-progress' state for segment status.
    const initProgress = (schema) => {
        //build a course level progress object
        const progressTree = {
            modules:schema.modules.map((module, moduleIndex) => {
                return {
                    lessons:module.lessons.map((lesson, lessonIndex) => {
                        return {
                            chapters:lesson.chapters.map((chapter, chapterIndex) => {
                                return {
                                    segments:chapter.segments.map((segment, segmentIndex) => {
                                        return {
                                            status: 'new',
					    complete:false,
                                            score:0,
                                        }
                                    })
                                }
                            })
                        }
                    })
                }
            })
        }
        setProgress(progressTree)
    }

    const markSegmentComplete = (location = currentLocation) => {
        if(progress === undefined) return console.log('markSegmentComplete() error: progress not initialized');
        try{
            let temp = _.cloneDeep(progress);
            temp.modules[location.module].lessons[location.lesson].chapters[location.chapter].segments[location.segment].status = 'complete';
	    temp.modules[location.module].lessons[location.lesson].chapters[location.chapter].segments[location.segment].complete = true;
            setProgress(temp)
        }catch (e){
            console.log('markSegmentComplete() error:', e, progress)
        }

    }

    const generateLocationLink = (location = currentLocation) => {
        const url = window.location.href;
        let queryString = ''
        Object.keys(location).forEach((key)=>{
            // console.log('generate', key, location[key])
            if(queryString === '' && url.indexOf('?') === -1){
                queryString += '?'
            }else{
                queryString += '&'
            }
            queryString += `${key}=${location[key]}`
        })
        return url + queryString;
    }

    useEffect(()=>{
        //wait for content data to load
        if(contentData){
            if(!progress) {
                initProgress(contentData)
            }
            if(contentData.activeModule){
                setLocationValue('module', contentData.activeModule)
            }
        }

    }, [contentData])

    const setBreadcrumbs = (data, location) => {
        if (!data) return false;
        const theLesson = data.modules[location.module].lessons[location.lesson] || ''
        let segment = data.modules[location.module].lessons[location.lesson]?.chapters[location.chapter]?.segments[location.segment]
        if (segment) {
            // Find Segment Title from Menu Data, WARNING: This assumes Menu is always the first item
            // TODO: find the Menu segment whenever it might be in the data.json
            const menu = data.modules[0]?.lessons[0]?.chapters[0]?.segments[0];
            if (!menu) {
                console.warn("MENU not found as first item in json data")
            }
            const menuItemRecord = menu.lessons.find( l => l.title === theLesson.name)?.chapters.find( c => c.tabName  === segment.sheetTitle)
            if (menuItemRecord) {
                segment = {
                    ...segment,
                    title: menuItemRecord.title
                }
            }
        }
        const breadcrumb = {
            module: data.modules[location.module],
            lesson: theLesson,
           // chapter: data.modules[location.module].lessons[location.lesson]?.chapters[location.chapter],
            segment: segment
        }
        return breadcrumb;

    }



    return (
        <LocationProvider value={{
            setCurrentLocation,
            currentLocation,
            resetSegment,
        }}>
        <div className={`Course ${contentData?.globals?.disableUserSelection === true && 'disable-user-selection'} 
            ${( (config.isAllenEnvironment && isQA === true) || config.isLocalHost)  ? 'review-view' : 'learner-view'}`}>





            {/* Content Loader - merges content JSON sheets into one big contentData object */}
            <ContentLoader
                contentData={contentData}
                setContentData={setContentData}
                useSheetsData={config.USE_SHEETS_DATA}
                sheetId={config.SHEET_ID}
            />

            {/* Image Preload - register images here to have them preloaded into DOM */}
            {/* currently a manual process - want to automate in future */}
            <ImagePreloader/>


            {/* Module - the actual content wrapper for 1 SCO, usually in a 1000x700 frame */}

            {
                (contentData && contentData.modules && currentLocation && (typeof currentLocation.module === 'number')) &&
                <Module
                    contentData={contentData}
                    moduleData={contentData.modules[currentLocation.module]}
                    currentLocation={currentLocation}
                    currentBreadCrumb={ setBreadcrumbs(contentData, currentLocation) }
                    setCurrentLocation={setCurrentLocation}
                    progress={progress}
                    setLocationValue={setLocationValue}
                    resetIndex={resetIndex}
                    resetSco={resetSco}
                    markSegmentComplete={markSegmentComplete}
                    setEditorShortcut={setEditorShortcut}
                    setLocationValues={setLocationValues}
                    isLocalHost={config.isLocalHost}
                    setQuit = {setQuit}
                />
            }

            {/* Tracking - routes progress/location events to APIs (SCORM/XAPI/JIRA) */}
            <Tracking
                contentData={contentData}
                currentLocation={currentLocation}
                progress={progress}
                setProgress={setProgress}
                setCurrentLocation={setCurrentLocation}
                generateLocationLink={generateLocationLink}
                quit={quit}
            />



            {/* Review Menu - Nav menu for review purposes w/ cheats*/}
            {(( config.isAllenEnvironment && isQA || config.isLocalHost) && contentData && contentData.modules && currentLocation && (typeof currentLocation.module === 'number')) &&
                <ReviewMenu
                    contentData={contentData}
                    currentLocation={currentLocation}
                    setCurrentLocation={setCurrentLocation}
                    resetSegment={resetSegment}
                    progress={progress}
                    markSegmentComplete={markSegmentComplete}
                    generateLocationLink={generateLocationLink}
                />}
            {/* Editor */}
            {(config.isLocalHost && contentData && currentLocation) &&
                <Editor
                    lessonURL={contentData.modules[currentLocation.module].lessons[currentLocation.lesson].url}
                    currentLocation={currentLocation}
                    contentData={contentData}
                    setContentData={setContentData}
                    config={config}
                    editorShortcut={editorShortcut}
                />
            }

        </div>
        </LocationProvider>
    )
}

export default Course
